import React from 'react'
import ButtonSortGroup from '../../blocks/buttons/ButtonSortGroup'

export default function InstrumentListSort(props) {
  const { searchParams } = props

  const buttons = [
    {label: '1 week', value: 'yield_1w'},
    {label: '1 month', value: 'yield_1m'},
    {label: '3 month', value: 'yield_3m'},
    {label: 'Name', value: 'name'},
  ]

  return (
    <div className="text-center">
      <ButtonSortGroup 
        searchParams={searchParams}
        queryParam='sort_by'
        buttons={buttons}
      />
    </div>
  )
}
